<template>
  <template v-if="hasConnection && isLegacy">
    <button
      class="tw-flex tw-gap-1.5 tw-text-action-link tw-underline hover:tw-no-underline hover:tw-cursor-pointer"
      data-test-id="msp-action-required"
      @click.stop="onButtonClick"
    >
      <span
        class="tw-h-2.5 tw-w-2.5 tw-shrink-0 tw-self-center tw-rounded-full tw-border-[3px] tw-border-system-warning-500 tw-bg-transparent"
      />
      <span>Update permissions</span>
    </button>
  </template>
  <template v-else-if="hasConnection">
    <div class="tw-flex tw-gap-1.5">
      <span
        class="tw-h-2.5 tw-w-2.5 tw-shrink-0 tw-self-center tw-rounded-full tw-bg-system-success-500"
      />
      <span>{{ $t("connected") }}</span>
    </div>
  </template>
  <template v-else>
    <authorisation-wrapper
      :resource="authorisationResource"
      :action="WRITE"
      v-slot="{ isAllowed: isWriteAllowed }"
    >
      <button
        class="tw-flex tw-gap-1 tw-text-action-link tw-underline"
        :class="
          isWriteAllowed
            ? 'hover:tw-no-underline hover:tw-cursor-pointer'
            : 'hover:tw-cursor-not-allowed'
        "
        :aria-disabled="!isWriteAllowed"
        data-test-id="msp-add-connection"
        @click.stop="
          () => {
            if (isWriteAllowed) {
              onButtonClick();
            }
          }
        "
      >
        <span>
          {{ $t("add-connection") }}
        </span>
      </button>
    </authorisation-wrapper>
  </template>
</template>

<script setup lang="ts">
import { AuthorisationWrapper, WRITE, type Resource } from "@/authorisation";

export type TCustomerConnectionProps = {
  hasConnection: boolean;
  isLegacy?: boolean;
  authorisationResource: Resource;
};

withDefaults(defineProps<TCustomerConnectionProps>(), {
  isLegacy: false,
});
const emit = defineEmits<{ (event: "clicked"): void }>();

const onButtonClick = () => emit("clicked");
</script>
